import React, { useEffect, useState } from "react";
import axios from "axios";
import Select from "react-select";
import { BASE_API_URL, DEFAULT_AXIOS_OPTIONS } from "../../../AppConstants";

export const UpdateGenre = ({ genres, setLastChangeOccured }) => {
  const [genreId, setGenreId] = useState(null);
  const [name, setName] = useState("");
  const [responseMessage, setResponseMessage] = useState(null);

  const onUpdateClick = () => {
    if (window.confirm(`Are you sure that you want to update?`)) {
      setResponseMessage("...Processing");

      axios
        .put(
          `${BASE_API_URL}/genre/${genreId}`,
          {
            name,
          },
          DEFAULT_AXIOS_OPTIONS
        )
        .then(() => {
          setResponseMessage("Success");
          setLastChangeOccured(new Date());
          setGenreId(null);
          setName("");
        })
        .catch((error) => {
          setResponseMessage("Error");
          console.error("error", error);
        });
    }
  };

  useEffect(() => {
    if (genreId) {
      axios
        .get(`${BASE_API_URL}/genre/${genreId}`, DEFAULT_AXIOS_OPTIONS)
        .then((res) => {
          const { name } = res.data;
          setName(name);
        })
        .catch((error) => {
          console.error("error", error);
        });
    } else {
      setName("");
    }
  }, [genreId]);

  const selectOptions = genres.map((genre) => ({
    value: genre.id,
    label: `${genre.name} (id: ${genre.id})`,
  }));

  const selectValue = selectOptions.find((option) => option.value === genreId);

  return (
    <>
      <h3 className="has-text-left is-size-4">Edit Genre</h3>
      <div className="column is-two-thirds">
        <Select
          value={selectValue || null}
          onChange={(selectedOption) => setGenreId(selectedOption?.value)}
          options={selectOptions}
          isClearable={true}
          isSearchable={true}
        />
      </div>
      <div className="column is-two-thirds">
        <input
          className="input"
          type="text"
          placeholder="Genre"
          value={name}
          onChange={(event) => setName(event.target.value)}
        />
      </div>
      <div className="column is-one-third">
        <button
          className="btn btn-danger"
          disabled={genreId === null || name === ""}
          onClick={onUpdateClick}
        >
          Update
        </button>
      </div>
      <p>{responseMessage ?? ""}</p>
    </>
  );
};
